const md5 = require("md5");
const { REACT_APP_KEY_ADMIN } = process.env;

export const save_role = (role) => {
  localStorage.setItem("role-redeem", md5(role + REACT_APP_KEY_ADMIN));
};

export const check_role = (role) => {
  return md5(role + REACT_APP_KEY_ADMIN) === localStorage.getItem("role-redeem");
};
